/**
 * @deprecated
 */
export const CATEGORY = {
  WEBSITE: 'Website',
};

/**
 * @deprecated
 */
export const EVENT_NAMES = {
  OPEN_APPLICATION_MODAL: 'Application modal opened',
  FAQ_OPENED: 'FAQ opened',
  START_APPLICATION: `Application started`,
  PAGE_VISITED: 'Website Visited',
};

/**
 * @deprecated
 */
export const START_APPLICATION = {
  category: CATEGORY.WEBSITE,
  event: EVENT_NAMES.START_APPLICATION,
};

/**
 * @deprecated
 */
export const OPEN_STEP_0_MODAL = {
  category: CATEGORY.WEBSITE,
  event: EVENT_NAMES.OPEN_APPLICATION_MODAL,
};

/**
 * @deprecated
 */
export const OPEN_CALCULATOR_STEP_0_MODAL = {
  ...OPEN_STEP_0_MODAL,
  payload: {
    ctaSource: 'Calculator',
  },
};

/**
 * @deprecated
 */
export const OPEN_HEADER_STEP_0_MODAL = {
  ...OPEN_STEP_0_MODAL,
  payload: {
    ctaSource: 'Header',
  },
};

/**
 * @deprecated
 */
export const OPEN_FOOTER_STEP_0_MODAL = {
  ...OPEN_STEP_0_MODAL,
  payload: {
    ctaSource: 'Footer',
  },
};

/**
 * @deprecated
 */
export const OPEN_HERO_BANNER_STEP_0_MODAL = {
  ...OPEN_STEP_0_MODAL,
  payload: {
    ctaSource: 'Hero Banner',
  },
};

/**
 * @deprecated
 */
export const OPEN_NAV_STEP_0_MODAL = {
  ...OPEN_STEP_0_MODAL,
  payload: {
    ctaSource: 'Nav Bar CTA',
  },
};

/**
 * @deprecated
 */
export const OPEN_QUESTIONS_STEP_0_MODAL = {
  ...OPEN_STEP_0_MODAL,
  payload: {
    ctaSource: 'Questions CTA',
  },
};

/**
 * @deprecated
 */
export const GET_STARTED_STEP_0_MODAL = {
  ...OPEN_STEP_0_MODAL,
  payload: {
    ctaSource: 'Get started CTA',
  },
};

/**
 * @deprecated
 */
export function getPageVisitedEvent() {
  return {
    category: CATEGORY.WEBSITE,
    event: EVENT_NAMES.PAGE_VISITED,
  };
}

/**
 * @deprecated
 */
export function getStep0ModalEventWithProductTypeAndText(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  event: any,
  ctaText: string,
  productType: string,
) {
  return {
    ...event,
    payload: {
      ...event.payload,
      ctaText,
      productType,
    },
  };
}

/**
 * @deprecated
 */
export function getFaqClicked(faqText: string) {
  return {
    category: CATEGORY.WEBSITE,
    event: EVENT_NAMES.FAQ_OPENED,
    payload: {
      faqText: faqText,
    },
  };
}
